<template>
    <b-modal :title="Core.Definition.getDefinition('Colonne')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                :options="{}"
                :ignoreRouteParamId="true"
                :getRoot="options.root.get"
                :formStructure="dataFormStructures.form">
            <slot slot="beforeFormButtons">
                <slot name="formButtons"></slot>
            </slot>
        </DynamicForm>
    </b-modal>
</template>

<script>
    var _self
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from './DynamicForm'
    import InputText from './InputText'
    import InputQuantity from './InputQuantity'
    import InputCheckbox from './InputCheckbox'
    export default {
        name: 'ModalFormBuilderColumn',
        components: {
            DynamicForm,
            InputText,
            InputQuantity,
            InputCheckbox
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            get: '/'
                        }
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            }
        },
        watch: {
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'label'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'id',
                                type: 'hidden',
                                value: ''
                            },
                            {
                                id: 'label',
                                type: 'text',
                                label: Core.Definition.getDefinition('Libellé'),
                                value: '',
                                required: true
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data, method) {
            },
            onInitSuccess(data) {
                this.$emit('onInitSuccess', data)
            }
        }
    }
</script>
